import React, { useState } from "react";
import {
  ArrowLeft,
  ArrowRight,
  Loader2,
  Sparkles,
} from "lucide-react";

const AZ_PREFIXES = ["50", "51", "55", "70", "77", "10", "60", "99"];

function formatPhone(digits) {
  const d = digits.slice(0, 9);
  const p1 = d.slice(0, 2);
  const p2 = d.slice(2, 5);
  const p3 = d.slice(5, 7);
  const p4 = d.slice(7, 9);
  let out = "";
  if (p1) out = p1;
  if (p2) out += " " + p2;
  if (p3) out += " " + p3;
  if (p4) out += " " + p4;
  return out;
}

function hasRegistrationForPhone(phone) {
  try {
    const raw = localStorage.getItem("pulpay_user");
    if (!raw) return false;
    const u = JSON.parse(raw);
    return !!(u && u.firstName && u.phone === phone);
  } catch (e) {
    return false;
  }
}

export default function PhoneEntry({ go, notify, onLogin }) {
  const [digits, setDigits] = useState("");
  const [loading, setLoading] = useState(false);
  const [toastNotif, setToastNotif] = useState(null); // { phone } | null

  const isValid = digits.length === 9 && AZ_PREFIXES.includes(digits.slice(0, 2));

  const handleChange = (e) => {
    const only = e.target.value.replace(/\D/g, "");
    setDigits(only.slice(0, 9));
  };

  const handleSubmit = () => {
    if (!isValid) {
      notify("Zəhmət olmasa düzgün nömrə daxil edin");
      return;
    }
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      const phone = "+994 " + formatPhone(digits);
      if (hasRegistrationForPhone(phone)) {
        onLogin(phone);
      } else {
        try { localStorage.setItem("pulpay_phone", phone); } catch (e) {}
        setToastNotif({ phone });
        // After 2s: dismiss and redirect to register
        setTimeout(() => {
          setToastNotif(null);
          onLogin(phone);
        }, 2000);
      }
    }, 1200);
  };

  return (
    <section className="screen phone-screen-v2">
      <div className="topbar">
        <button className="icon-btn" onClick={() => go("splash")}>
          <ArrowLeft size={22} />
        </button>
        <div className="section-title">Giriş</div>
        <span style={{ width: 38 }} />
      </div>

      <div className="content ph-content">
        <div className="ph-bg-orb ph-bg-orb-1" />
        <div className="ph-bg-orb ph-bg-orb-2" />

        <div className="ph-logo-block">
          <div className="ph-logo-halo" />
          <img src="/assets/logo.png" alt="PULPAY" className="ph-logo-img" />
          <span className="ph-logo-flash" />
          <span className="ph-logo-sp ph-logo-sp-1"><Sparkles size={12} /></span>
          <span className="ph-logo-sp ph-logo-sp-2"><Sparkles size={10} /></span>
        </div>

        <div className="ph-welcome">
          <h2>PULPAY-ə xoş gəldiniz</h2>
          <p>Hesabınıza daxil olmaq üçün mobil nömrənizi qeyd edin.</p>
        </div>

        <div className="ph-field">
          <label>Mobil nömrə</label>
          <div className="ph-input-wrap">
            <span className="ph-cc">
              <span className="ph-flag" aria-label="Azərbaycan">
                <svg viewBox="0 0 30 20" width="22" height="16" aria-hidden="true">
                  <rect width="30" height="6.67" y="0" fill="#00b5e2" />
                  <rect width="30" height="6.66" y="6.67" fill="#ef3340" />
                  <rect width="30" height="6.67" y="13.33" fill="#00af66" />
                  <circle cx="13.5" cy="10" r="2.6" fill="#ffffff" />
                  <circle cx="14.5" cy="10" r="2.2" fill="#ef3340" />
                  <polygon fill="#ffffff" points="17.4,10 17.9,10.7 18.7,10.9 18.1,11.5 18.2,12.3 17.4,12 16.6,12.3 16.7,11.5 16.1,10.9 16.9,10.7" transform="translate(0,-2)" />
                </svg>
              </span>
              <span>+994</span>
            </span>
            <div className="ph-divider" />
            <input
              type="tel"
              inputMode="numeric"
              placeholder="50 123 45 67"
              value={formatPhone(digits)}
              onChange={handleChange}
              autoFocus
            />
          </div>
        </div>

        <button
          className="ph-cta"
          onClick={handleSubmit}
          disabled={!isValid || loading}
        >
          {loading ? (
            <>
              <Loader2 size={18} className="spin" /> Yoxlanılır...
            </>
          ) : (
            <>
              Giriş et <ArrowRight size={18} strokeWidth={3} />
            </>
          )}
        </button>

        <div className="ph-legal">
          Davam etməklə <b>İstifadə şərtləri</b> və <b>Məxfilik siyasəti</b> ilə razılaşırsınız.
        </div>
      </div>

      {/* Top slide-in toast notification — WhatsApp style */}
      {toastNotif && (
        <div
          className="ph-topnotif"
          onClick={() => {
            setToastNotif(null);
            onLogin(toastNotif.phone);
          }}
          data-testid="phone-notif-toast"
        >
          <div className="ph-topnotif-bar">
            <div className="ph-topnotif-logo">
              <img src="/assets/logo.png" alt="PULPAY" />
            </div>
            <div className="ph-topnotif-body">
              <div className="ph-topnotif-head">
                <b>PULPAY</b>
                <span>indi</span>
              </div>
              <div className="ph-topnotif-title" data-testid="phone-notif-title">
                Bu nömrədə qeydiyyat tapılmadı
              </div>
              <div className="ph-topnotif-sub">{toastNotif.phone}</div>
            </div>
          </div>
          <div className="ph-topnotif-progress" />
        </div>
      )}
    </section>
  );
}
